import React from "react";
import { PageHero, CtaBanner } from "../components/shared";
import { DetailedServiceGrid } from "../components/ServiceCards";

export default function ServicesPage() {
  return (
    <>
      <PageHero
        crumb="Services"
        eyebrow="Our Services"
        title="Comprehensive Technical Services"
        subtitle="Installation, integration, maintenance, and support across six technical disciplines — delivered by qualified engineers to current industry standards."
      />
      <section className="py-20 lg:py-28 bg-white">
        <div className="max-w-[1240px] mx-auto px-5 lg:px-8">
          <DetailedServiceGrid />
        </div>
      </section>
      <CtaBanner />
    </>
  );
}
